import { API_PRIVATE_HOST, API_PUBLIC_HOST } from "@/_constant";
import api from "./request";

export async function getUserDetails() {
  try {
    const userResp = await api.get(`${API_PUBLIC_HOST}/user/viewUser`);
    if(userResp.status === 200){
      return userResp.data;
    }
    throw Error("Failed to get user details");
  } catch (err){
    throw err;
  }
}

export function userAddress(categoryId){
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.get(`${API_PUBLIC_HOST}/user/listAddressForCategory?categoryId=${categoryId}`);
            resolve(res);
        } catch(err){
            reject(err);
        }
    })
}

export function fetchUserAccessList(status){
    return new Promise(async (resolve, reject) => {
        let url = `${API_PUBLIC_HOST}/user/listUserAccess?filterActiveDates=false&hideReplacedPlans=true`
        if(status && Array.isArray(status)){
            url += `&status=${encodeURIComponent(status.join(","))}`
        }

        try {
            const res = await api.get(url);
            resolve(res);
        } catch(err){
            reject(err);
        }
    })
}

export function addOrUpdateUserAccessMetadata(userAccessId, metadataType, metadataValue=""){
    const url = `${API_PRIVATE_HOST}/registration/addOrUpdateUserAccessMetadata?userAccessId=${userAccessId}`;
    const payload = {
        accessKey: metadataType,
        accessValue: metadataValue
    }
    return api.put(url, payload);
}

export function viewUserProfile(userAccessId){
    const url = `${API_PUBLIC_HOST}/userAccessProfile/viewUserProfile?userAccessId=${userAccessId}`;
    return api.get(url);
}

export function viewUserAccessMetadata(userAccessId){
    const url = `${API_PUBLIC_HOST}/user/viewUserAccess?userAccessId=${userAccessId}`;
    return api.get(url);
}

export const listAddresses = () =>
    api.get(`${API_PUBLIC_HOST}/user/listAddress`);

export const updateOnboardingUser = (payload) =>
    api.post(`${API_PUBLIC_HOST}/user/updateUser`, payload);

export const saveOnboardingAddress = (payload) =>
    api.post(`${API_PUBLIC_HOST}/user/addAddress`, payload);

export const addOrGetOnboardingUserAccess = (payload) =>
    api.post(`${API_PUBLIC_HOST}/user/addOrGetUserAccess`, payload);
